import API from './API';
import ClientOAuth2 from 'client-oauth2';
import { ProcessEnv } from '../types';
import { GetActiveCountryCookie } from './Helper';

declare let process: ProcessEnv

const DEBUG_MODE_VALIDATE = process.env.VUE_APP_DEBUG_MODE_VALIDATE && process.env.VUE_APP_ENV !== 'production';
var refreshTokenPromise = undefined as Promise<ClientOAuth2.Token> | undefined;

interface OAuthConf {
  [key: string]: string
}

//Get domain from window location to callback to for OAUTH
const domainForCallback = (window ? window.location.origin : '');

/**
 * @class APIHelper
 * Handles OAuth request with the server
 */
class APIHelper {
  AuthAPIs = [] as API[]
  NonAuthAPIs = [] as API[]

  OAUTH_SERVER_CONF = {
    OAUTH_SERVER_URL: process.env.VUE_APP_OAUTH_SERVER_URL,
    CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    CLIENT_SECRET: process.env.VUE_APP_CLIENT_SECRET,
    CALLBACK_URL: `${domainForCallback}/passback`,
  } as OAuthConf;

  oauthObj = new ClientOAuth2({
    clientId: this.OAUTH_SERVER_CONF.CLIENT_ID,
    clientSecret: this.OAUTH_SERVER_CONF.CLIENT_SECRET,
    accessTokenUri: this.OAUTH_SERVER_CONF.OAUTH_SERVER_URL + '/oauth/token',
    authorizationUri: this.OAUTH_SERVER_CONF.OAUTH_SERVER_URL + '/oauth/authorize',
    redirectUri: this.OAUTH_SERVER_CONF.CALLBACK_URL,
    scopes: undefined,//['DDD_Report'],
  }) as ClientOAuth2;

  token: ClientOAuth2.Token | undefined;

  AuthAPI = new API(process.env.VUE_APP_OAUTH_SERVER_URL);
  AdminAPI = new API(process.env.VUE_APP_API_URL_ADMIN);
  ArchistarAPI = new API(process.env.VUE_APP_API_URL_ARCHISTAR);
  GeneratorAPI = new API(process.env.VUE_APP_API_URL_GENERATOR);
  HomesMgmtAPI = new API(process.env.VUE_APP_API_URL_HOMESMGMT);
  AcademyAPI = new API(process.env.VUE_APP_API_URL_ACADEMY);
  WorkspaceAPI = new API(process.env.VUE_APP_API_URL_WORKSPACE);
  CommunityAPI = new API(process.env.VUE_APP_API_URL_COMMUNITY);
  DocumentAPI = new API(process.env.VUE_APP_API_URL_DOCUMENT);
  ManageAPI = new API(process.env.VUE_APP_API_URL_MANAGE);
  DnaAPI = new API(process.env.VUE_APP_API_URL_DNA);
  GnafSearchAPI = new API(process.env.VUE_APP_API_URL_GNAF_SEARCH);
  ExternalAPI = new API(null);

  constructor() {
    this.AuthAPIs.push(this.AuthAPI);
    this.AuthAPIs.push(this.AdminAPI);
    this.AuthAPIs.push(this.ArchistarAPI);
    this.AuthAPIs.push(this.GeneratorAPI);
    this.AuthAPIs.push(this.HomesMgmtAPI);
    this.AuthAPIs.push(this.AcademyAPI);
    this.AuthAPIs.push(this.WorkspaceAPI);
    this.AuthAPIs.push(this.CommunityAPI);
    this.AuthAPIs.push(this.DocumentAPI);
    this.AuthAPIs.push(this.ManageAPI);
    this.AuthAPIs.push(this.DnaAPI);
    this.AuthAPIs.push(this.GnafSearchAPI);
    this.NonAuthAPIs.push(this.ExternalAPI);

    const countryCode = GetActiveCountryCookie();
    this.AuthAPIs.forEach((itApi) => {
        itApi.setHeaderCommons('X-as-country-code', countryCode ?? 'au');
    });

    if (this.isUserLoggedIn()) {
      this.AuthAPIs.forEach((itApi: API) => {
        itApi.setHeaderCommons('Authorization', 'Bearer ' + localStorage.getItem("tka"));
      });
      this.token = this.oauthObj.createToken(localStorage.getItem("tka") ?? "", localStorage.getItem("tkr") ?? "", 'authorization_code', {});
    }
  }

  isUserLoggedIn() {
    return (localStorage.getItem("tka") !== null && localStorage.getItem("tkr") !== null);;
  }

  async validateToken() {
    if (DEBUG_MODE_VALIDATE) console.log('validateToken - start', 'access', localStorage.getItem("tka"), 'refresh', localStorage.getItem("tkr"));

    if (!(localStorage.getItem("tka") !== null && localStorage.getItem("tkr") !== null)) {
      if (DEBUG_MODE_VALIDATE) console.log('validateToken - no token, rejecting');
      return await this.refreshToken();
    } else {

      try {
        const valResp = await this.AuthAPI?.get('/auth/validatetoken');
        if (DEBUG_MODE_VALIDATE) console.log('validateToken _ /auth/validatetoken[then]', valResp);

        if (typeof valResp !== "undefined" && valResp.hasOwnProperty('data') && valResp.data.result === 'success') {
          if (DEBUG_MODE_VALIDATE) console.log('validateToken - valid token, resolving');

          return true;
        }

      } catch (x) {

      }

      return await this.refreshToken();
    }
  }

  async refreshToken() {
    if (DEBUG_MODE_VALIDATE) console.log('refreshToken - start', 'access', localStorage.getItem("tka"), 'refresh', localStorage.getItem("tkr"));

    const ref_tok = localStorage.getItem("tkr");
    if ((ref_tok == null) || (typeof ref_tok === "undefined")) {
      if (DEBUG_MODE_VALIDATE) console.log('refreshToken - no refresh token, rejecting');
      return false;
    }
    // if the token is already beeing refreshed return a promise
    if (refreshTokenPromise) {
      return refreshTokenPromise;
    }

    try {
      refreshTokenPromise = this.token?.refresh({
        body: {
          client_id: this.OAUTH_SERVER_CONF.CLIENT_ID,
          client_secret: this.OAUTH_SERVER_CONF.CLIENT_SECRET,
        },
      });
      const updatedToken = await refreshTokenPromise;
      if (typeof updatedToken !== "undefined" && updatedToken.hasOwnProperty("accessToken")) {

        if (DEBUG_MODE_VALIDATE) console.log('refreshToken _ refresh[then], store & resolve', updatedToken);

        // Store access and refresh tokens
        localStorage.setItem("tka", updatedToken.accessToken);
        localStorage.setItem("tkr", updatedToken.refreshToken);

        // Use access token for auth in API calls
        this.AuthAPIs.forEach((itApi: API) => {
          itApi.setHeaderCommons('Authorization', 'Bearer ' + updatedToken.accessToken);
        });
        this.token = this.oauthObj?.createToken(updatedToken.accessToken, updatedToken.refreshToken, 'authorization_code', {}) ?? undefined;
        refreshTokenPromise = undefined;
        return true;
      } else {
        if (DEBUG_MODE_VALIDATE) console.log('refreshToken _ refresh[then - bad], clear & reject');
      }
    } catch (e) {
      if (DEBUG_MODE_VALIDATE) console.log('refreshToken _ refresh[catch], clear & reject', e);
    }

    // Remove stored access and refresh tokens
    localStorage.removeItem("tka");
    localStorage.removeItem("tkr");

    // Clear access token for auth in API calls
    this.AuthAPIs.forEach((itApi: API) => {
      itApi.setHeaderCommons('Authorization', null);
    });
    refreshTokenPromise = undefined;
    this.token = undefined;
    return false;
  }

  handleLogin(req: any) {
    //Store intended route & redirect to auth route
    let intRoute = req.fullPath;
    if (req.query.hasOwnProperty('intendedroute')) {
      intRoute = req.query.intendedroute;
    }
    localStorage.setItem('intended_route', intRoute)
    window.location.href = this.oauthObj?.code.getUri() ?? "";
  }

  async handleLogout() {
    await this.AuthAPI?.post('/auth/logout');
    //Store intended route & redirect to auth route
    localStorage.removeItem("userBasics");
    localStorage.removeItem("tka");
    localStorage.removeItem("tkr");
    localStorage.removeItem('intended_route');
    this.AuthAPIs.forEach((itApi: API) => {
      itApi.setHeaderCommons('Authorization', null);
    });
  }

  handleCallback(req: any) {
    const intendedRoute = localStorage.getItem('intended_route') as string;
    localStorage.removeItem('intended_route');
    return new Promise((resolve) => {
      this.oauthObj?.code.getToken(req.fullPath, {
        body: {
          client_id: this.OAUTH_SERVER_CONF.CLIENT_ID,
          client_secret: this.OAUTH_SERVER_CONF.CLIENT_SECRET,
        },
      }).then((newToken: ClientOAuth2.Token) => {
        // Store access and refresh tokens
        localStorage.setItem("tka", newToken.accessToken);
        localStorage.setItem("tkr", newToken.refreshToken);

        // Use access token for auth in API calls
        this.AuthAPIs.forEach((itApi: API) => {
          itApi.setHeaderCommons('Authorization', 'Bearer ' + newToken.accessToken);
        });
        this.token = this.oauthObj?.createToken(localStorage.getItem("tka") ?? "", localStorage.getItem("tkr") ?? "", 'authorization_code', {}) ?? undefined;
        window.location.href = intendedRoute;
        resolve(true);
      })
    });
  }

  getCurrentWebToken(): string | null {
    return localStorage.getItem('tka')
  }

  hasCurrentWebToken(): boolean {
    if (localStorage.getItem('tka')) {
      return true
    }
    return false
  }

  getCurrentRefreshToken() : string | null {
    return localStorage.getItem('tkr')
  }

  hasCurrentRefreshToken(): boolean {
    if (localStorage.getItem('tkr')) {
      return true
    }
    return false
  }
}

export default new APIHelper();
